import { render, staticRenderFns } from "./ExtendsFields.vue?vue&type=template&id=6095c036&scoped=true"
import script from "./ExtendsFields.vue?vue&type=script&lang=js"
export * from "./ExtendsFields.vue?vue&type=script&lang=js"
import style0 from "./ExtendsFields.vue?vue&type=style&index=0&id=6095c036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6095c036",
  null
  
)

export default component.exports